import { render, staticRenderFns } from "./CommunitySharing.vue?vue&type=template&id=0cf3fb0c"
import script from "./CommunitySharing.vue?vue&type=script&lang=js"
export * from "./CommunitySharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports